import { configureStore } from "@reduxjs/toolkit";
import previewSlice from "features/preview/slice";

export const store = configureStore({
  reducer: {
    preview: previewSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
